import { render, staticRenderFns } from "./MaterialLov.vue?vue&type=template&id=1ae41e0e&"
import script from "./MaterialLov.vue?vue&type=script&lang=js&"
export * from "./MaterialLov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports